/**
 * Wrapper async pra `canvas-confetti` — carrega a lib só quando o confete
 * vai disparar (momento raro: primeiro check-in, conquista desbloqueada,
 * rank-up). Evita ~10kB gzip no bundle inicial.
 *
 * API quase identica ao confetti() original. Retorna Promise<void> em vez
 * de Promise<undefined>; chamar com void pra fire-and-forget.
 */

// Tipo mínimo replicado pra não importar tipos da lib (que carregariam o pacote).
type ConfettiOptions = {
  particleCount?: number;
  angle?: number;
  spread?: number;
  origin?: { x?: number; y?: number };
  colors?: string[];
  ticks?: number;
  startVelocity?: number;
  decay?: number;
  gravity?: number;
  drift?: number;
  scalar?: number;
  shapes?: Array<'square' | 'circle' | 'star'>;
};

type ConfettiFn = (opts: ConfettiOptions) => Promise<void>;

let cached: ConfettiFn | null = null;
let loading: Promise<ConfettiFn> | null = null;

async function load(): Promise<ConfettiFn> {
  if (cached) return cached;
  if (loading) return loading;
  loading = (async () => {
    const mod = await import('canvas-confetti');
    cached = mod.default as unknown as ConfettiFn;
    return cached;
  })();
  return loading;
}

/** Dispara confete. Não bloqueia — se a lib falhar de carregar, silencia. */
export async function fireConfetti(opts: ConfettiOptions): Promise<void> {
  try {
    const fn = await load();
    await fn(opts);
  } catch (err) {
    console.warn('[confetti] falha ao carregar/disparar', err);
  }
}

/** Pre-carrega a lib (chame antes do momento crítico). */
export function preloadConfetti(): void {
  void load();
}
